var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main-layout',[_c('h2',[_vm._v("Account Details")]),_c('auth-settings'),_c('br'),(_vm.user.isExecutive)?_c('schedule-delegation'):_vm._e(),_c('br'),(_vm.user.isExecutive)?_c('credits-ledger'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }